import React, { FunctionComponent } from 'react';
import Slider from 'react-slick';
import type { ComponentProps } from './types';

const PrevArrow = (props: any) => {
  const { onClick } = props;
  return <div className="articles-featured-prev" onClick={onClick} />;
};

const NextArrow = (props: any) => {
  const { onClick } = props;
  return <div className="articles-featured-next" onClick={onClick} />;
};

const isSP = typeof window !== 'undefined' && window.innerWidth < 781;

const settings = {
  autoplay: true,
  centerMode: true,
  centerPadding: isSP ? '5%' : '0',
  dots: true,
  variableWidth: !isSP,
  arrows: !isSP,
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,
  responsive: [
    {
      breakpoint: 781,
      settings: {
        arrows: false,
        dots: true,
        variableWidth: false,
        centerPadding: '5%',
      },
    },
  ],
};

export const Presentation: FunctionComponent<ComponentProps> = ({
  recruitments,
  isNewgrad,
  hoverIcon,
  noimage,
}) => {
  const category = isNewgrad ? 'newgrad_topcontent' : 'topcontent';

  return (
    <section className="sitetop-section">
      <div className="sitetop-contents">
        <Slider {...settings} className="sitetop-contents-slide">
          {recruitments.map((recruitment, index) => (
            <a
              key={recruitment.id}
              href={`/recruitments/${recruitment.id}`}
              className="c-related-article-card__link gtm-recruitment-view-count"
              style={{ width: 573 }}
              data-event-name="recruitments on screen"
              data-event="click"
              data-category={category}
              data-value={index < 5 ? `featured_recruitment${index + 1}` : 'featured_recruitment'}
              data-recruitmentid={recruitment.id}
              data-companyid={recruitment.companyId}
            >
              <div className="articles-featured-card articles-featured-card--bg">
                <div className="articles-featured-img article-card-img">
                  <img
                    src={recruitment.image ? recruitment.image.url : noimage}
                    alt={`${recruitment.title || ''}のカバー写真`}
                  />
                  <div className="article-card-hover">
                    <img src={hoverIcon} alt="" />
                  </div>
                </div>
                <div className="articles-featured-heading">
                  <p className="articles-featured-heading-title">
                    {recruitment.title}
                  </p>
                  <div className="articles-featured-heading-inner">
                    <div className="articles-featured-heading-content">
                      {recruitment.employmentType && (
                        <div className="articles-featured-heading-tag">
                          <i className="fas fa-user" />
                          <div className="articles-featured-heading-tag-text">
                            {recruitment.employmentType}
                          </div>
                        </div>
                      )}
                      {recruitment.regularEmployee && (
                        <p className="articles-featured-heading-employee">正社員</p>
                      )}
                      {recruitment.address && (
                        <div className="articles-featured-heading-address">
                          <i className="fas fa-map-marker-alt" />
                          <div className="articles-featured-heading-address-text">
                            {recruitment.address}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="article-card-author article-card-author--flex">
                    <span className="article-card-author-logo">
                      <img
                        src={recruitment.companyIcon}
                        alt={recruitment.companyIcon.includes('default') ? 'アイコン画像' : `${recruitment.companyName}のロゴ写真`}
                      />
                    </span>
                    <span className="articles-featured-card-author-name">
                      {recruitment.companyName}
                    </span>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </Slider>
      </div>
    </section>
  );
};
